import { useSyncExternalStore } from 'react';

/**
 * Reactive subscription to a CSS media query via matchMedia.
 *
 * Canonical React 19 pattern for browser-API subscriptions —
 * useSyncExternalStore is the dedicated primitive (concurrent-safe,
 * server-snapshot-aware, no useEffect race). Returns the current
 * `matches` value and re-renders the component when it changes.
 *
 * SSR-safe: `getServerSnapshot` returns false (treat as non-matching
 * during server render — no window available).
 */
export function useMatchMedia(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener('change', notify);
      return () => mediaQueryList.removeEventListener('change', notify);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
